/**
 * GripCorner — the classic bottom-right "resize" grip: two diagonal strokes
 * tucked into a corner, as on a native resizable textarea.
 *
 * Purely decorative (`aria-hidden`): pair it with a labelled interactive
 * element such as `EdgeResizeHandle` rather than using it on its own.
 */
export function GripCorner({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width='10'
      height='10'
      viewBox='0 0 10 10'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.25'
      strokeLinecap='round'
      aria-hidden='true'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M9 1L1 9' />
      <path d='M9 5.5L5.5 9' />
    </svg>
  );
}
